export enum Values {
  decToHex,
  decToBin,
  hexToDec,
  hexToBin,
  binToDec,
  binToHex,
  tabLenght,
}
